import { parseVastMobileClientFromUserAgent } from './mobileUserAgent'
import { isUsingMobileAuthentication } from './isMobileAppClient'

/**
 * Parses the mobile app version from the user agent or the window.
 *
 * @returns {string | undefined} The mobile app version if the user is using a mobile app, otherwise undefined.
 */
export const getMobileAppVersion = () => {
  const knownMobileClient = parseVastMobileClientFromUserAgent(
    window.navigator.userAgent,
  )

  if (knownMobileClient) {
    // Return the version from the parsed client
    return knownMobileClient.version
  } else if (isUsingMobileAuthentication()) {
    /**
     * Versions < 1.0.58 will set the version in the window object.
     * Legacy applications will not, but they will use mobile authentication,
     * so return 0.0.0 to indicate it is known that we are on mobile.
     */
    return window.REACT_NATIVE_APP_VERSION || '0.0.0'
  }

  // Web client or unknown
  return undefined
}

export * from './isMobileAppClient'
export * from './mobileUserAgent'
